import { getTokenClientes } from "../Store/storages/AuthenticationStorage";
import { apiClientes } from "../config/api";
import { AnexosSolic, Guia } from "../interfaces/entities/Guia";
import { GuiaParaRevalidacao } from "../interfaces/entities/GuiaParaRevalidacao";
import { ProtocsSolicsBenef } from "../interfaces/entities/ProtocsSolicsBenef";

export const getMinhasGuias = async (): Promise<Guia[] | null> => {
    try {
        const response = await apiClientes.get('/Guia/GetMinhasGuias',{
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` } 
        });
      return response.data; // Retornar o valor da resposta, não a resposta completa
        
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const getCartaNegativa = async (idSolic: string): Promise<string> => {
    try {
        const response = await apiClientes.get('/Guia/GetCartaNegativa?idSolic=' + idSolic,{
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` } 
        });

      // Remove as aspas
      return response.data.replace(/^["'](.*)["']$/, '$1');
        
    } catch (error) {
        console.log({ error });
        return '';
    }
};

export const anexarDocumentoGuia = async (
    idSolic: string,
    extensao: string,
    base64: string,
): Promise<any | null> => {
    const response = await apiClientes.post(`/Guia/anexardocumento`,{
        idSolic,
        extensao,
        arquivo: base64,
        canal: 'CLIPF'
    }, { headers: { Authorization: `Bearer ${await getTokenClientes()}`}});
    return response.data;
}

export const concluirSolicitacao = async (
  idSolic: string,
): Promise<any | null> => {
  const token = await getTokenClientes();
  const response = await apiClientes.post(
    `/Guia/concluirsolicitacao?idSolic=${idSolic}&canal=CLIPF`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return response.data;
};

export const getAllDocumentosGuia = async (
    idSolic: string,
): Promise<AnexosSolic[] | null> => {
    const response = await apiClientes.get(`/Guia/GetDocumentos?idSolic=${idSolic}`, 
        { headers: { Authorization: `Bearer ${await getTokenClientes()}`}});
    return response.data;
}

export const getDocumentoGuia = async (
    idSolic: string,
    numAnexo: string,
    extensao: string,
): Promise<AnexosSolic | null> => {
    const response = await apiClientes.get(`/Guia/GetDocumento?idSolic=${idSolic}&numAnexo=${numAnexo}&extensao=${extensao}`, 
        { headers: { Authorization: `Bearer ${await getTokenClientes()}`}});
    return response.data;
}

export const getProtocsSolicsBenef = async (): Promise<ProtocsSolicsBenef[] | null> => {
    try {
        const response = await apiClientes.get('Guia/GetProtocsSolicsBenef',{
            headers: { Authorization: `Bearer ${await getTokenClientes()}` } 
        });
      return response.data; // Retornar o valor da resposta, não a resposta completa
        
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const getGuiasParaRevalidacao = async (): Promise<GuiaParaRevalidacao[] | null> => {
    try {
        const response = await apiClientes.get('Guia/GetGuiasParaRevalidacao',{
            params: {indVencida: 'S'},
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` } 
        });
      return response.data; // Retornar o valor da resposta, não a resposta completa
        
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const getGuiaSADT = async (idSolic: string): Promise<any | null> => {
    try {
        const response = await apiClientes.get('/Guia/GetGuiaSADT',{
            params: {idSolic},
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` } 
        });
      return response.data; // Retornar o valor da resposta, não a resposta completa
        
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const getCTE = async (idSolic: string): Promise<any | null> => {
    try {
        const response = await apiClientes.get('/Guia/GetCTE',{
            params: {idSolic},
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` } 
        });
      return response.data; // Retornar o valor da resposta, não a resposta completa
        
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const getProtocoloGuiaFutura = async (idProtoc: string, idSolic: string): Promise<any | null> => {
    try {
        const response = await apiClientes.get('Guia/GetProtocoloGuiaFutura',{
            params: {
                idProtoc,
                idSolic
            },
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` } 
        });
      return response.data; // Retornar o valor da resposta, não a resposta completa
        
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const ativarGuiaFutura = async (idProtocSolic: string): Promise<any | null> => {
    try {
        const response = await apiClientes.post('Guia/AtivarGuiaFutura',{
                idProtocSolic
            },
            {
                headers: { Authorization: `Bearer ${await getTokenClientes()}`}
            }
        );
      return response.data; // Retornar o valor da resposta, não a resposta completa
        
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const revalidarGuia = async (idSolic: string, indVencida: string): Promise<any | null> => {
    try {
        const response = await apiClientes.post('Guia/RevalidarGuia',{
                idSolic,
                indVencida
            },
            {
                headers: { Authorization: `Bearer ${await getTokenClientes()}`}
            }
        );
      return response;
        
    } catch (error) {
        console.log({ error });
        return null;
    }
};